const STORAGE_KEY_TOKEN = 'userToken';

export default {
  getToken() {
    return localStorage.getItem(STORAGE_KEY_TOKEN);
  },
  setToken(token) {
    localStorage.setItem(STORAGE_KEY_TOKEN, token);
  }
};
